




















import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "cultureHeritage",
})
export default class extends Vue {
  @Prop()
  inputCultureHeritageData: any;

  @Watch("inputCultureHeritageData", { immediate: true, deep: true })
  oninputCultureHeritageData(val: any, oldVal: any) {
    this.cultureHeritageData = val;
    // console.log('-----xxxx-------',val)
  }

  private cultureHeritageData: any = [];

  private strSub(str: any, len: any) {
    if (str.length > len) {
      return str.substr(0, len) + "..."; //截取元素的文本的长度并加上省略号
    }
  }

  private toDetail(item: any) {
    this.$router.push({
      name: "Article",
      query: {
        type: "1",
        landmarkId: item.landmark_id,
        id: item.id,
      },
    });
  }
}
